export var actionTypes;
(function (actionTypes) {
    actionTypes["IMPORT"] = "IMPORT/START";
    actionTypes["EXPORT"] = "EXPORT/START";
    actionTypes["IMPORT_REFRESH"] = "IMPORT/REFRESH";
    actionTypes["EXPORT_REFRESH"] = "EXPORT/REFRESH";
    actionTypes["IMPORT_PENDING"] = "IMPORT/PENDING";
    actionTypes["IMPORT_ERROR"] = "IMPORT/ERROR";
    actionTypes["IMPORT_FINISH"] = "IMPORT/FINISH";
    actionTypes["EXPORT_PENDING"] = "EXPORT/PENDING";
    actionTypes["EXPORT_ERROR"] = "EXPORT/ERROR";
    actionTypes["EXPORT_FINISH"] = "EXPORT/FINISH";
    actionTypes["ADD_IMPORT_EXPORT_CHUNK"] = "IMPORTEXPORT/ADD_IMPORT_EXPORT_CHUNK";
    actionTypes["CLEAN_IMPORT_EXPORT_CHUNK"] = "IMPORTEXPORT/CLEAN_IMPORT_EXPORT_CHUNK";
})(actionTypes || (actionTypes = {}));
//# sourceMappingURL=actionTypes.js.map